import {
  SIMP_OFFICIAL_WEBSITE_EDU_URL,
  SIMP_OFFICIAL_WEBSITE_URL,
  STU_WEBSITE_URL,
} from '@/constants';

import { removeQueryParam } from './url';

const SIMP_OFFICIAL_WEBSITE_URL_TEST =
  process.env.NEXT_PUBLIC_OFFICIAL_WEBSITE_DOMAIN;
const IS_PROD = process.env.NEXT_PUBLIC_ENV === 'prod';

interface GoWebsiteOptions {
  selectedLang?: string;
  openInNewWindow?: boolean;
}

const openUrl = (url: string, openInNewWindow?: boolean) => {
  if (openInNewWindow) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};

export const goWebSite = (
  path: string | null = null,
  options?: GoWebsiteOptions,
) => {
  const { openInNewWindow, selectedLang } = options || {};
  const lang =
    selectedLang || globalThis.location.pathname.includes('/zh/') ? 'zh' : 'en';
  // 线上环境针对国内用户，格外提供一个 www-intl.wukongedu.net 的官网域名用于登录，然后跳转到 student.wukongedu.net 这个域名
  const prodWebsiteUrl =
    window.location.hostname.includes('wukongedu.net') ||
    window.location.hostname.includes('vercel.app')
      ? `${SIMP_OFFICIAL_WEBSITE_EDU_URL}/${lang}`
      : `${SIMP_OFFICIAL_WEBSITE_URL}/${lang}`;
  const officialWebsiteUrlTest = `${SIMP_OFFICIAL_WEBSITE_URL_TEST}/${lang}`;

  let finalHref = window.location.href;
  if (window.location.hostname.includes('vercel.app')) {
    finalHref = IS_PROD
      ? `${STU_WEBSITE_URL}/${lang}`
      : `${SIMP_OFFICIAL_WEBSITE_URL_TEST}/${lang}`;
  }

  const hostName = IS_PROD ? prodWebsiteUrl : officialWebsiteUrlTest;

  if (path) {
    openUrl(`${hostName}/${path}`, openInNewWindow);
    return;
  }

  /* 如果是注销账号的页面，注销成功后再登录后回到首页 */
  if (window.location.href.includes('home/close-account')) {
    openUrl(`${hostName}/student-center-login`, openInNewWindow);
    return;
  }

  const url = removeQueryParam(finalHref, 'from');
  openUrl(
    `${hostName}/student-center-login?return_url=${encodeURIComponent(url)}`,
    openInNewWindow,
  );
};
